"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingBoxRadioButtonGroupView = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var SettingBoxRadioButtonView_1 = require("./SettingBoxRadioButtonView");
function SettingBoxRadioButtonGroupView(props) {
    var data = props.data, onClick = props.onClick;
    var _a = tslib_1.__read(react_1.useState(data[0].text), 2), option = _a[0], SetOption = _a[1];
    var handleOption = function (option) {
        SetOption(option);
        onClick(option);
    };
    return (react_1.default.createElement("div", null, data.map(function (item, index) { return (react_1.default.createElement("div", { key: index },
        option !== item.text && (react_1.default.createElement(SettingBoxRadioButtonView_1.SettingBoxRadioButtonViewDefault, { text: item.text, des: item.des, color: item.color, onClick: handleOption })),
        option === item.text && (react_1.default.createElement(SettingBoxRadioButtonView_1.SettingBoxRadioButtonViewChoosed, { text: item.text, des: item.des, color: item.color, onClick: handleOption })))); })));
}
exports.SettingBoxRadioButtonGroupView = SettingBoxRadioButtonGroupView;
//# sourceMappingURL=index.js.map